module.exports = __webpack_public_path__ + "static/media/product5.9e9528de.jpg";